<template>
  <div class="RedirectToFirst">
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
const pagesHelper = createNamespacedHelpers('pages')
export default {
  name: 'RedirectToFirst',
  data () {
    return {}
  },
  created () {
    this.toFirstPage()
  },
  computed: {},
  mounted () {},
  methods: {
    ...pagesHelper.mapActions(['toFirstPage'])
  }
}
</script>

<style scoped lang="scss">
  .RedirectToFirst{

  }
</style>



// WEBPACK FOOTER //
// src/views/RedirectToFirst/index.vue